var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddHomeWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_527_30456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 125
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 125,
    height: 125,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_527_30456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2439 35.2567H98.2567V27.2439H90.2439V35.2567ZM94.2503 104.167C88.4477 104.167 83.5249 102.145 79.4817 98.1023C75.4386 94.0591 73.417 89.1363 73.417 83.3337C73.417 77.5311 75.4386 72.6082 79.4817 68.565C83.5249 64.5219 88.4477 62.5003 94.2503 62.5003C100.053 62.5003 104.976 64.5219 109.019 68.565C113.062 72.6082 115.084 77.5311 115.084 83.3337C115.084 89.1363 113.062 94.0591 109.019 98.1023C104.976 102.145 100.053 104.167 94.2503 104.167ZM92.2471 98.3578H96.2536V85.3369H109.274V81.3304H96.2536V68.3096H92.2471V81.3304H79.2262V85.3369H92.2471V98.3578ZM115.084 55.0384C112.166 52.728 108.9 50.9903 105.288 49.8251C101.676 48.6599 97.9963 48.0773 94.2503 48.0773C92.4274 48.0773 90.6529 48.2158 88.9268 48.4929C87.2007 48.77 85.503 49.1957 83.8337 49.77V44.2712L54.5869 23.2775V10.417H115.084V55.0384ZM10.917 93.7503V49.4795L42.167 27.2438L73.417 49.4795V55.0985C68.9031 58.2502 65.3708 62.3584 62.82 67.4232C60.2693 72.488 58.9939 77.7915 58.9939 83.3337C58.9939 85.2902 59.1258 87.058 59.3895 88.6372C59.6533 90.2163 60.0924 91.9207 60.7067 93.7503H51.7824V67.308H32.5516V93.7503H10.917Z",
    fill: "#E4E4E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHomeWork);
export default __webpack_public_path__ + "static/media/add-home-work.e491496e8efd2650e36d16977e1c752b.svg";
export { ForwardRef as ReactComponent };